<mat-card appearance="outlined" *ngIf="meta.signature_url && meta.user_name">
  <mat-card-content>
    <span class="sc-custom-label">{{ title }}</span>

    <img [src]="meta.signature_url" [alt]="'Signature of ' + meta.user_name" />

    <mat-hint *ngIf="meta.user_name">Signed by <b>{{ meta.user_name }}</b> {{ meta.signed_at ? ('on ' + (meta.signed_at*1000 | timezoneConvertLong)) : '' }}.</mat-hint>
  </mat-card-content>
</mat-card>
